module.exports = __webpack_public_path__ + "img/icon_db_1.e60ef32b.svg";